!((document, Drupal) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.relatedServices = {
    attach: function (context) {
      const component = context.querySelectorAll('.related-services__wrap');

      component.forEach((item) => {
        const listItems = item.querySelectorAll('.related-services__items li');

        if (listItems.length > 10) {
          // button
          const expand = document.createElement('div');
          expand.classList.add('related-services__expand');
          const showButton = document.createElement('a');
          showButton.innerText = 'View More';
          const icon = document.createElement('span');
          showButton.appendChild(icon);
          expand.appendChild(showButton);

          showButton.addEventListener('click', function () {
            if (item.classList.contains('related-services--active')) {
              showButton.innerText = 'View More';
              const icon = document.createElement('span');
              showButton.appendChild(icon);
              item.classList.remove('related-services--active');
            }
            else {
              showButton.innerText = 'View Less';
              const icon = document.createElement('span');
              showButton.appendChild(icon);
              item.classList.add('related-services--active');
            }
          });
          item.appendChild(expand);
        }
      });
    }
  };
})(document, Drupal);
